'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _IrcdDiffs = require('@/helpers/IrcdDiffs');

var IrcdDiffs = _interopRequireWildcard(_IrcdDiffs);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function inviteListSorter(a, b) {
    var aMask = a.invited.toUpperCase();
    var bMask = b.invited.toUpperCase();

    if (aMask < bMask) {
        return -1;
    }
    if (aMask > bMask) {
        return 1;
    }

    return 0;
}

exports.default = {
    props: ['buffer'],
    data: function data() {
        return {
            inviteList: [],
            is_refreshing: false
        };
    },

    computed: {
        supportsAccounts: function supportsAccounts() {
            return !!this.extban;
        },
        extban: function extban() {
            return IrcdDiffs.extbanAccount(this.buffer.getNetwork());
        },
        inviteListAccounts: function inviteListAccounts() {
            var _this = this;

            var accounts = this.inviteList.filter(function (i) {
                return i.invited.indexOf(_this.extban) === 0;
            });
            accounts.sort(inviteListSorter);
            return accounts;
        },
        inviteListNonAccounts: function inviteListNonAccounts() {
            var _this2 = this;

            var invites = [];

            if (!this.supportsAccounts) {
                invites = this.inviteList;
            } else {
                invites = this.inviteList.filter(function (i) {
                    return i.invited.indexOf(_this2.extban) !== 0;
                });
            }

            invites.sort(inviteListSorter);
            return invites;
        },
        channelIsInviteOnly: function channelIsInviteOnly() {
            return typeof this.buffer.modes.i !== 'undefined';
        },
        anyRegisteredUserCanJoin: function anyRegisteredUserCanJoin() {
            if (!this.supportsAccounts) {
                return false;
            }

            if (!this.channelIsInviteOnly) {
                return false;
            }

            var extban = this.extban;

            return !!this.inviteListAccounts.find(function (invite) {
                return invite.invited === extban + ':';
            });
        },
        areWeAnOp: function areWeAnOp() {
            return this.buffer.isUserAnOp(this.buffer.getNetwork().nick);
        },
        knownAccounts: function knownAccounts() {
            var users = this.buffer.getNetwork().users;
            var extban = this.extban;
            var inviteAccountNames = this.inviteListAccounts.map(function (i) {
                var mask = i.invited;
                return mask.replace(extban + ':', '');
            });

            var accountUsers = [];
            (0, _values2.default)(users).forEach(function (user) {
                if (user.account && inviteAccountNames.indexOf(user.account) === -1) {
                    accountUsers.push(user);
                }
            });

            return _lodash2.default.orderBy(accountUsers, ['account', 'nick']);
        }
    },
    created: function created() {
        this.updateInvitelist();
    },

    methods: {
        displayMask: function displayMask(invite) {
            var display = invite.invited.replace(this.extban + ':', '');
            display = display || this.$t('invite_any_registered');
            return display;
        },
        updateInvitelist: function updateInvitelist() {
            var _this3 = this;

            if (this.buffer.getNetwork().state !== 'connected' || this.is_refreshing) {
                return;
            }
            var channelName = this.buffer.name;
            this.is_refreshing = true;
            this.buffer.getNetwork().ircClient.inviteList(channelName, function (inviteEvent) {
                if (inviteEvent) {
                    _this3.inviteList = inviteEvent.invites;
                } else {
                    _this3.inviteList = [];
                }

                _this3.is_refreshing = false;
            });
        },
        removeInvite: function removeInvite(mask) {
            var channelName = this.buffer.name;
            this.buffer.getNetwork().ircClient.removeInvite(channelName, mask);
            this.inviteList = this.inviteList.filter(function (invite) {
                return invite.invited !== mask;
            });
        },
        addAccountInvite: function addAccountInvite(accountName) {
            if (!accountName) {
                return;
            }

            var network = this.buffer.getNetwork();
            network.ircClient.addInvite(this.buffer.name, this.extban + ':' + accountName);
            this.updateInvitelist();
        },
        addInvite: function addInvite(mask) {
            var network = this.buffer.getNetwork();
            network.ircClient.addInvite(this.buffer.name, mask);
            this.updateInvitelist();
        },
        setInviteOnly: function setInviteOnly() {
            this.buffer.getNetwork().ircClient.mode(this.buffer.name, '+i');
        },
        removeInviteOnly: function removeInviteOnly() {
            this.buffer.getNetwork().ircClient.mode(this.buffer.name, '-i');
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ChannelInvitelist.vue
// module id = VSWv
// module chunks = 1